import * as tslib_1 from "tslib";
import { Vue } from "vue-property-decorator";
import { store } from "store";
var StartView = /** @class */ (function (_super) {
    tslib_1.__extends(StartView, _super);
    function StartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        return _this;
    }
    StartView.prototype.routed = function () {
        this.$router.clearHistory();
        store.page.title = this.$t("startView.title");
        store.page.showTopNav = false;
    };
    StartView.prototype.setLocale = function (locale) {
        this.$i18n.locale = locale;
    };
    return StartView;
}(Vue));
export default StartView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/StartView.vue
// module id = 71
// module chunks = 0